export const of_transports_displayed_columns_locale = {
  transportMode: "Transport mode",
  companyName: "Transport company",
  partyType: "Party type"
};
